<template>
    <el-dialog title="开通VIP" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-vip">
    <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
    <img src="../assets/images/close.png" alt="关闭" @click="cancelVipHandler()">
    <p>该功能需要激活会员后才能使用，是否激活?</p>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelVipHandler" class="vip-btn1">取消</el-button>
        <el-button type="primary" @click="clickVipHandler" class="vip-btn2">激活会员</el-button>
    </div>
    </el-dialog>
</template>

<script>
export default {
    name: "Vip",
    data() {
        return {
        };
    },
    computed: {
    },
    created() {
    },
    methods: {
        cancelVipHandler() {
            localStorage.setItem("isNewUser","false");
            this.$store.commit("user/SHOWVIP",false);
        },
        clickVipHandler() {
            localStorage.setItem("isNewUser","false");
            this.$store.commit("user/SHOWVIP",false);
            this.$store.commit("user/SHOWADDVIP",true);
        }
    }
}
</script>

<style lang='scss' scoped>
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    p {
        margin: 40px 0;
        color: #5e6166;
        font-size: 16px;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 240px;
            height: 52px;
            border-radius: 8px;
            font-size: 18px!important;
            border: none;
        }
        .vip-btn1 {
            background: #e1e4eb!important;
            color: #5e6166!important;
            background: #e1e4eb!important;
        }
        .vip-btn2 {
            background: linear-gradient(133deg,#ffce5d 1%, #ffa02f 97%, #ffa02f 97%)!important;
            color: #ffffff!important;
        }
    }
}
</style>